import { useEffect, useRef, useState } from "react";
import { withRouter } from "react-router-dom";
import Navbar from "./Website/Layouts/Navbar";
import Footer from "./Website/Layouts/Footer";
import SplashScreen from "./Website/SplashScreen";
import { useSite } from "contexts/SiteContext";

// Module-level flag: survives React Router navigation but resets on page refresh.
// This guarantees the splash only plays once per full page load.
let _splashShown = false;

const AUTH_PATHS = ["/login", "/register", "/forget-password"];

const NonAuthBuyerLayout = ({ children, location }) => {
	const { settingsLoaded } = useSite();
	const [showSplash, setShowSplash] = useState(!_splashShown);
	const [exiting, setExiting] = useState(false);

	const minDone = useRef(false);
	const dataReady = useRef(false);
	const dismissed = useRef(false);

	const tryDismiss = () => {
		if (dismissed.current || !showSplash) return;
		if (minDone.current && dataReady.current) {
			dismissed.current = true;
			_splashShown = true;
			setExiting(true);
			// let exit animation finish before unmounting
			setTimeout(() => setShowSplash(false), 600);
		}
	};

	// Minimum display time: 2.5 s so animations can complete
	useEffect(() => {
		if (!showSplash) return;
		const timer = setTimeout(() => {
			minDone.current = true;
			tryDismiss();
		}, 2500);
		return () => clearTimeout(timer);
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	// Dismiss as soon as settings API finishes (success or error)
	useEffect(() => {
		if (settingsLoaded && showSplash) {
			dataReady.current = true;
			tryDismiss();
		}
	}, [settingsLoaded]); // eslint-disable-line react-hooks/exhaustive-deps

	const isAuthPage = AUTH_PATHS.includes(location?.pathname);

	return (
		<div
			style={{
				minHeight: "100vh",
				background: "linear-gradient(180deg, #17121c 0%, #28102a 100%)",
			}}>
			{showSplash && <SplashScreen exiting={exiting} />}
			{!isAuthPage && <Navbar />}
			{children}
			{!isAuthPage && <Footer />}
		</div>
	);
};

export default withRouter(NonAuthBuyerLayout);
